export default __webpack_public_path__ + "static/media/space-planning.3efd23d5.svg";